import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "_flexcol _gap-4 _py-2",
  "data-qa": "project-properties-box"
}
const _hoisted_2 = { class: "_ov-h" }
const _hoisted_3 = { class: "gfu-project-banner__field-label" }
const _hoisted_4 = { class: "gfu-media _mt-2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "gfu-media__body _flexcol _gap-1 _ov-h" }
const _hoisted_7 = { class: "gfu-hd gfu-hd--h2 _toe" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "_whs-nw" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "_ov-h"
}
const _hoisted_13 = { class: "gfu-project-banner__field-label" }
const _hoisted_14 = {
  key: 0,
  class: "gfu-media _mt-2"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "gfu-media__body _flexcol _gap-1 _ov-h" }
const _hoisted_17 = { class: "gfu-hd gfu-hd--h2 _toe" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "_flex _gap-2 _flexwrap _mt-2 _ai-c"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "_grid _grid-cols-2 _grid-cols-3--m _row-gap-4" }
const _hoisted_24 = {
  key: 0,
  "data-qa": "project-properties:Players"
}
const _hoisted_25 = { class: "gfu-project-banner__field-label" }
const _hoisted_26 = { class: "gfu-project-banner__field-value _mt-1" }
const _hoisted_27 = {
  key: 1,
  "data-qa": "project-properties:PlayTime"
}
const _hoisted_28 = { class: "gfu-project-banner__field-label" }
const _hoisted_29 = { class: "gfu-project-banner__field-value _mt-1" }
const _hoisted_30 = {
  key: 2,
  "data-qa": "project-properties:Age"
}
const _hoisted_31 = { class: "gfu-project-banner__field-label" }
const _hoisted_32 = { class: "gfu-project-banner__field-value _mt-1" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "gfu-project-banner__field-label" }
const _hoisted_35 = { class: "gfu-project-banner__field-value gfu-project-banner__field-value--tags" }
const _hoisted_36 = {
  key: 2,
  class: "_col-span-2",
  "data-qa": "project-properties:Genre"
}
const _hoisted_37 = { class: "gfu-project-banner__field-label" }
const _hoisted_38 = { class: "gfu-project-banner__field-value gfu-project-banner__field-value--tags" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_tag = _resolveComponent("base-tag")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["_grid _gap-4", { '_grid-cols-2--l': $setup.hasCoCreators }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryCreatorLabel), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          ($setup.mappedCreator.avatarUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: $setup.mappedCreator.url,
                class: "_mr-3",
                "data-qa": "project-properties:AvatarImage"
              }, [
                _createVNode(_component_base_image, {
                  src: $setup.mappedCreator.avatarUrl,
                  alt: $setup.mappedCreator.name,
                  width: "48",
                  height: "48",
                  class: "_rounded--common",
                  loading: "lazy"
                }, null, 8 /* PROPS */, ["src", "alt"])
              ], 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, [
              _createElementVNode("a", {
                href: $setup.mappedCreator.url,
                class: "gfu-link gfu-link--nofx _whs-nw",
                "data-qa": "project-properties:CreatorName"
              }, _toDisplayString($setup.mappedCreator.name), 9 /* TEXT, PROPS */, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                href: $setup.mappedCreator.url,
                class: "gfu-link gfu-link--accent _mr-2",
                rel: "nofollow",
                "data-qa": "project-properties:MoreInfo"
              }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryMoreInfoLink), 9 /* TEXT, PROPS */, _hoisted_10),
              _createElementVNode("a", {
                href: _ctx.projectContactUrl,
                class: "gfu-link gfu-link--accent",
                "data-qa": "project-properties:Contact"
              }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryContactLink), 9 /* TEXT, PROPS */, _hoisted_11)
            ])
          ])
        ])
      ]),
      ($setup.hasCoCreators)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString($options.coCreatorSectionLabel), 1 /* TEXT */),
            ($setup.hasOneCoCreator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  ($setup.firstCoCreator.avatarUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.firstCoCreator.url,
                        class: "_mr-3"
                      }, [
                        _createVNode(_component_base_image, {
                          class: "_rounded--common",
                          src: $setup.firstCoCreator.avatarUrl,
                          alt: $setup.firstCoCreator.name,
                          width: "48",
                          height: "48",
                          loading: "lazy"
                        }, null, 8 /* PROPS */, ["src", "alt"])
                      ], 8 /* PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h3", _hoisted_17, [
                      _createElementVNode("a", {
                        href: $setup.firstCoCreator.url,
                        class: "gfu-link gfu-link--nofx _whs-nw",
                        "data-qa": "project-properties:CoCreatorName"
                      }, _toDisplayString($setup.firstCoCreator.name), 9 /* TEXT, PROPS */, _hoisted_18)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        href: $setup.firstCoCreator.url,
                        class: "gfu-link gfu-link--accent _whs-nw",
                        rel: "nofollow"
                      }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryMoreInfoLink), 9 /* TEXT, PROPS */, _hoisted_19)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mappedCoCreators, (coCreator) => {
                    return (_openBlock(), _createBlock(_component_tooltip, {
                      key: coCreator.url,
                      tag: "span",
                      mode: $options.isMobile ? 'click' : 'hover',
                      "is-link-behavior-preserved": !$options.isMobile,
                      "data-qa": `project-co-creator-name:${coCreator.name}`
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(coCreator.name), 1 /* TEXT */),
                        ($options.isMobile)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: coCreator.url,
                              class: "gfu-link _tdu _ml-1",
                              onTouchstart: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryMoreInfoLink), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_22))
                          : _createCommentVNode("v-if", true)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: coCreator.url
                        }, [
                          _createVNode(_component_base_image, {
                            src: coCreator.avatarUrl || $options.placeholderImageUrl,
                            alt: coCreator.name,
                            width: "48",
                            height: "48",
                            class: "_rounded--common",
                            loading: "lazy"
                          }, null, 8 /* PROPS */, ["src", "alt"])
                        ], 8 /* PROPS */, _hoisted_21)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["mode", "is-link-behavior-preserved", "data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_23, [
      ($options.gameSpecificProjectPropertiesEnabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($options.playersLabelContent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesPlayersLabel), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_26, _toDisplayString($options.playersLabelContent), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($options.playTimeLabelContent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesPlayTimeLabel) + " ", 1 /* TEXT */),
                    ($props.projectProperties.playTimeDescription)
                      ? (_openBlock(), _createBlock(_component_tooltip, {
                          key: 0,
                          text: $props.projectProperties.playTimeDescription,
                          "icon-name": "circle-info",
                          class: "gfu-project-banner__tooltip"
                        }, null, 8 /* PROPS */, ["text"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString($options.playTimeLabelContent), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($props.projectProperties.minAge)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesAgeLabel), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_32, _toDisplayString($props.projectProperties.minAge) + " + ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (!!$props.projectCategory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesCategoryLabel), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(), _createBlock(_component_base_tag, {
                key: $props.projectCategory.name,
                theme: "accent",
                href: $props.projectCategory.url,
                class: "_mr-1",
                tag: "a"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.projectCategory.name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href"]))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($options.projectHasTags)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesTagsLabel), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleProjectTags, (tag) => {
                return (_openBlock(), _createBlock(_component_base_tag, {
                  key: tag.name,
                  href: tag.url,
                  class: "_mr-1",
                  tag: "a"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}